
import { useState, useCallback, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { SET_SHARE_LINK_DIALOGUE_SHOWING, GET_SHARE_SCHEDULE_LINK, } from '../actions/types';
import { siteboardAction, } from '../actions/defaultActions';
import { debugLog, copyToClipboard, } from '../Util.js';

import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

import LinkIcon from '../icons/linkIcon';
import CircleCheckIcon from '../icons/circleCheckIcon';
import Logo from '../SiteBoard_Logo';

const ShareLinkDialogue = ({ _projects, _schedules, _shareScheduleLinkDialogueScheduleId, _projectsContactEmails, siteboardAction }) => {

  const linkFetchState = useRef('none');
  const [linkLoaded, setLinkLoaded] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const [showLinkCopySuccessPop, setShowLinkCopySuccessPop] = useState(false);
  const [shareScheduleLink, setShareScheduleLink] = useState('');

  const closeDialogue = useCallback(() => {
    siteboardAction(SET_SHARE_LINK_DIALOGUE_SHOWING, { isOpen: false });
  }, [siteboardAction]);

  const selectedSchedule = _schedules[_shareScheduleLinkDialogueScheduleId];

  useEffect(() => {
    if(!selectedSchedule) return;
    if(linkFetchState.current !== 'none') return;
    linkFetchState.current = 'loading';

    const onSuccess = (validOutput) => {
      setShareScheduleLink(validOutput.shareLink);
      setLinkLoaded(true);
      linkFetchState.current = 'done';
    };
    siteboardAction(GET_SHARE_SCHEDULE_LINK, {
      scheduleId: selectedSchedule.id,
      projectId: selectedSchedule.projectId,
    }, onSuccess);
  }, [selectedSchedule, selectedSchedule.projectId, siteboardAction]);

  if(selectedSchedule === undefined) return (<></>);

  const selectedProject = _projects[selectedSchedule.projectId];
  if(selectedProject === undefined) return (<></>);

  return (
    <PopupWindow 
      title={'Share Schedule Link'}
      closeDialogue={closeDialogue}
      bgStyle='bg-neutral-800'
    >
      <div className={`flex flex-col gap-4 max-w-screen-sm text-white`}>
        <div className='w-[100vw] max-w-full'>
          <div className=''>Allow anyone to view the latest published schedule for <b>{selectedProject.name}</b>.</div>
          {/*<div className='opacity-70'>Or the most recent 3-week if no schedule has been published.</div>*/}
        </div>
        {/*<div className=''>If they’re on the project contacts list, they’ll also be able to sign up for email updates.</div>*/}
        {/*<div className=''>You can disable the link at any time if needed.</div>*/}
        {linkLoaded && shareScheduleLink.length > 0  &&
          <div className={`flex flex-col justify-start items-start gap-2 bg-neutral-900 p-6 rounded-lg text-[1.2em] break-all`}>
            {linkCopied === true ?
              <div className={`flex items-start gap-2 ${showLinkCopySuccessPop ? 'animate-pop' : ''}`}>
                <CircleCheckIcon size='1.4em' color='#00bc7d' />
                <div>Link Copied to Clipboard</div>
              </div>
              :
              <div>Here's the link:</div>
            }
            <div><b>{shareScheduleLink}</b></div>
          </div>
        }
        {!linkLoaded &&
          <div className='flex justify-start items-center gap-2 bg-neutral-900 p-6 rounded-lg text-[1.2em] break-all'>
            <div className='animate-[spin_1s_linear_infinite]'>
              <Logo size='1.8em' />
            </div>
            <p className='select-none font-medium'>Loading Link</p>
          </div>
        }
        <div className='flex gap-4'>
          <button  
            className={`border border-[#888] hover:border-[#000] hover:bg-[#000] text-white w-full py-[7px] font-bold select-none rounded-lg`}
            onClick={() => { closeDialogue(); }}
          >
            Cancel
          </button>
          <PushButton 
            disabled={!linkLoaded}
            textColor='black'
            bgColor='#f9a928'
            hoverBgColor='#f79800'
            onClick={() => {
              try {
                copyToClipboard(shareScheduleLink); // copy link to clipboard
                setLinkCopied(true);
                setShowLinkCopySuccessPop(false);
                setTimeout(() => {
                  setShowLinkCopySuccessPop(true);
                }, 10);
              } catch (err) {
              }
            }}
          >
            <div className='flex items-center gap-x-[6px]'>
              <LinkIcon size='1.4em' color={'#000'} />
              <div>Copy Link</div>
            </div>
          </PushButton>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _projects: state.serverSynced.projects,
  _schedules: state.serverSynced.schedules,
  _shareScheduleLinkDialogueScheduleId: state.localEphemeral.shareScheduleLinkDialogueScheduleId,
  _projectsContactEmails: state.serverSynced.projectsContactEmails,
}};
export default connect(mapStateToProps, { siteboardAction })(ShareLinkDialogue);
